import { render, staticRenderFns } from "./auth-card.vue?vue&type=template&id=7f86f20b&"
import script from "./auth-card.vue?vue&type=script&lang=js&"
export * from "./auth-card.vue?vue&type=script&lang=js&"
import style0 from "./auth-card.vue?vue&type=style&index=0&id=7f86f20b&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports